export const filterAndSortHabitaciones = ({ habitaciones, query, estado }) => {
    const q = String(query || "").trim().toLowerCase();

    const list = (Array.isArray(habitaciones) ? habitaciones : []).filter((h) => {
        const matchesText =
            !q ||
            [h?.nombre, h?.descripcion, h?.comentarios]
                .filter(Boolean)
                .some((t) => String(t).toLowerCase().includes(q));

        const matchesEstado =
            estado === "todos" ||
            (estado === "libres" && !!h?.disponible) ||
            (estado === "ocupadas" && !h?.disponible);

        return matchesText && matchesEstado;
    });

    list.sort((a, b) =>
        String(a?.nombre || "").localeCompare(String(b?.nombre || ""), "es")
    );

    return list;
};

export const computeHabitacionesKpis = (list) => {
    const arr = Array.isArray(list) ? list : [];
    const libres = arr.filter((h) => !!h?.disponible).length;
    const ocupadas = arr.filter((h) => !h?.disponible).length;

    return {
        total: arr.length,
        libres,
        ocupadas,
    };
};
